import { genericJourneyResolverMapping } from '@dxb-web-ui-framework/mocks/msw/types';
import { genericMapToHandlers } from '@dxb-web-ui-framework/mocks/msw/utils/genericMapToHandlers';
import { ecommbx } from '../../index';

const orderMap: genericJourneyResolverMapping[] = [
  { url: /\/api\/private\/orders\/standing\/\d+/, response: () => ecommbx.standingOrdersDetailsData, method: 'get' },
  { url: /\/api\/private\/orders\/sweep\/\d+/, response: () => ecommbx.sweepOrdersDetailsData, method: 'get' },
  { url: /\/api\/private\/orders\/standing/, response: () => ecommbx.standingOrdersData, method: 'get' },
  { url: /\/api\/private\/orders\/sweep/, response: () => ecommbx.sweepOrdersData, method: 'get' },
  { url: /\/api\/private\/orders\/standing/, response: () => null, method: 'post' },
  { url: /\/api\/private\/orders\/sweep/, response: () => null, method: 'post' },
];

const orderHandlers = orderMap.map(genericMapToHandlers);

export { orderHandlers };
